import { isEqual } from "lodash";
import useIsPermittedTo from "PFCore/helpers/use_is_permitted_to";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import useAutoAllocationSettings from "PFCore/hooks/use_auto_allocation_settings";
import { ApiRoute } from "PFCore/utilities/routes";
import { PermissionRule } from "PFTypes";
import { useCallback, useEffect, useState } from "react";

const useWorkflowAutomation = () => {
  const [workflowAutomation, setWorkflowAutomation] = useState(null);
  const { data: currentProfile } = useCurrentProfile();
  const { always_on, setAlwaysAllocate } = useAutoAllocationSettings();
  const isPermittedTo = useIsPermittedTo(currentProfile);

  const isAuditAdmin = isPermittedTo(PermissionRule.AuditAdmin);

  const getAllocationStatus = () => {
    if (!workflowAutomation) {
      return null;
    }
    if (always_on) {
      return "autorun";
    }
    if (workflowAutomation.auto_filling > 0) {
      return "allocating";
    }
    if (workflowAutomation.auto_shortlisting > 0) {
      return "autoShortlisting";
    }
    if (workflowAutomation.pending > 0) {
      return "pending";
    }
    return "completed";
  };

  const fetchWorkflowAutomation = () => {
    $.ajax({
      url: ApiRoute("/api/workflow_automation"),
      api_version: 2
    }).then((resp) => {
      if (!isEqual(resp, workflowAutomation)) {
        setWorkflowAutomation(resp);
      }
    });
  };

  useEffect(() => {
    if (!isAuditAdmin) {
      return; //Avoid calling if 422 is guaranteed
    }

    if (!workflowAutomation) {
      fetchWorkflowAutomation();
    }
    const interval = setInterval(fetchWorkflowAutomation, 5000);
    return () => {
      clearInterval(interval);
    };
  }, [workflowAutomation]);

  const startWorkflowAutomation = useCallback(() => {
    if (workflowAutomation?.auto_filling > 0 || !isAuditAdmin) {
      return; //Avoid calling if 422 is guaranteed
    }

    $.ajax({
      url: ApiRoute("/api/workflow_automation"),
      method: "POST",
      api_version: 2
    });
  }, []);

  return {
    workflowAutomation,
    setWorkflowAutomation,
    fetchWorkflowAutomation,
    startWorkflowAutomation,
    setAlwaysAllocate,
    isAuditAdmin,
    allocationStatus: getAllocationStatus()
  };
};

export default useWorkflowAutomation;
